'use client'

import React, { useMemo } from 'react'
import { useLocale, useTranslations } from 'next-intl'

import type { ContactSupportData } from '@/src/constants/contactSupport'

import { ContactFormView } from './contactForm'

const ContactFormWrapper: React.FC<{ supportData: ContactSupportData }> = ({ supportData }) => {
    const t = useTranslations('contact')
    const locale = useLocale()
    const isRtl = locale === 'ar'

    const copy = useMemo(
        () => ({
            customerService: t('customerService'),
            forWhatsApp: t('forWhatsApp'),
            callsFrom:
                supportData.callsFromLine ??
                t('callsFrom', { region: supportData.callsFromRegion ?? supportData.address }),
            internationalWhatsapp: t('internationalWhatsapp'),
            officeAddressTitle: t('officeAddressTitle'),
            contactNumber: t('contactNumber'),
            registeredNumber: t('registeredNumber'),
            vat: supportData.vatLineKind === 'taxCard' ? t('taxCard') : t('vat')
        }),
        [supportData.address, supportData.callsFromLine, supportData.callsFromRegion, supportData.vatLineKind, t]
    )

    return <ContactFormView supportData={supportData} isRtl={isRtl} copy={copy} />
}

export { ContactFormWrapper }
export default ContactFormWrapper
